const markerKey = 'stayon.auth.session-epoch';

export interface SessionEpoch {
  epoch: number;
  loggedOut: boolean;
}

export interface LogoutFinality {
  read(): SessionEpoch;
  advance(loggedOut: boolean): SessionEpoch;
  adopt(state: SessionEpoch): SessionEpoch;
}

const initial: SessionEpoch = { epoch: 0, loggedOut: false };

export function createLogoutFinality(): LogoutFinality {
  let fallback = initial;
  const storage = typeof localStorage === 'undefined' ? null : localStorage;

  const read = (): SessionEpoch => {
    if (!storage) return fallback;
    try {
      const parsed = JSON.parse(storage.getItem(markerKey) ?? '') as Partial<SessionEpoch>;
      return typeof parsed.epoch === 'number' && typeof parsed.loggedOut === 'boolean'
        ? { epoch: parsed.epoch, loggedOut: parsed.loggedOut }
        : fallback;
    } catch {
      return fallback;
    }
  };

  const write = (state: SessionEpoch) => {
    fallback = state;
    try {
      storage?.setItem(markerKey, JSON.stringify(state));
    } catch {
      // Memory fallback still protects the current document when storage is unavailable.
    }
    return state;
  };

  return {
    read,
    advance: (loggedOut) => {
      const current = read();
      return write({ epoch: Math.max(Date.now(), current.epoch + 1), loggedOut });
    },
    adopt: (state) => (state.epoch >= read().epoch ? write(state) : read()),
  };
}
